<template>
  <div
    class="affirm"
    v-show="isShow"
    v-move="'.title'"
  >
    <div
      class="title"
    >
      {{title}}
      <div
        class="close"
        @click="close"
      >X</div>
    </div>
    <div class="content">
      <slot></slot>
    </div>

    <div class="button">
      <button @click="affirm">确定</button>
      <button @click="close">取消</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: { type: String, default: "默认标题" },
    isShow: { type: Boolean, default: false },
  },
  methods: {
    // 确定
    affirm() {
      this.$emit("yesAffirm");
    },
    //取消窗体
    close() {
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="less" scoped>
.affirmHint {
  .content {
    margin-bottom: 37px !important;
    padding: 0 47px 0;
  }
}
.affirm {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  height: 240px;
  opacity: 1;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
  .title {
    position: relative;
    width: 350px;
    height: 50px;
    opacity: 1;
    background: #3831ff;
    border-radius: 10px 10px 0px 0px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    color: #ffffff;
    line-height: 50px;
    .close {
      position: absolute;
      top: 13px;
      right: 13px;
      width: 24px;
      height: 24px;
      opacity: 1;
      background: #00b7ee;
      border-radius: 50%;
      line-height: 24px;
    }
  }
  .content {
    margin-top: 49px;
    margin-bottom: 55px;
  }
  .button {
    text-align: center;
    button {
      width: 80px;
      height: 40px;
      opacity: 1;
      border-radius: 6px;
      outline: none;
      border: 0 none;
      color: #fff;
      &:nth-child(1) {
        background: #3170ff;
        margin-right: 30px;
      }

      &:nth-child(2) {
        background: #efbc00;
      }
    }
  }
}
</style>